import controller_0 from '@symfony/ux-live-component/dist/live_controller.js';
import '@symfony/ux-live-component/dist/live.min.css';
import controller_1 from 'vite-plugin-symfony/stimulus/helpers/react/render_controller';

export default [
{
        enabled: true,
        fetch: "eager",
        identifier: "live",
        controller: controller_0
      },
{
        enabled: true,
        fetch: "eager",
        identifier: "symfony--ux-react--react",
        controller: controller_1
      }
];
